import { atom, useAtomValue, useSetAtom } from 'jotai';

const v53NotificationShownAtom = atom<boolean>(false);
v53NotificationShownAtom.debugLabel = 'v53NotificationShown';

export function useSetAtomV53NotificationShown() {
  return useSetAtom(v53NotificationShownAtom);
}

export function useAtomValueV53NotificationShown() {
  return useAtomValue(v53NotificationShownAtom);
}
